export enum ModuleEnum {
  SYSTEM_MANAGEMENT = "SYSTEMADMIN",
  HR_MANAGEMENT = "HR_MANAGEMENT",
  CATEGORY_MANAGEMENT = "CATEGORY",
  WMS = "WMS",
}